"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StoresContext_1 = require("./StoresContext");
var connect = function (storeName) {
    return function (Component) {
        var StoreConnection = /** @class */ (function (_super) {
            __extends(StoreConnection, _super);
            function StoreConnection(props) {
                var _this = _super.call(this, props) || this;
                _this.storeSubscription = null;
                _this.store = null;
                _this.store = _this.props.stores[storeName];
                _this.handleStoreUpdate = _this.handleStoreUpdate.bind(_this);
                return _this;
            }
            StoreConnection.prototype.componentDidMount = function () {
                this.storeSubscription = this.store.update$.subscribe(this.handleStoreUpdate);
            };
            StoreConnection.prototype.componentWillUnmount = function () {
                this.storeSubscription.unsubscribe();
            };
            StoreConnection.prototype.render = function () {
                return (React.createElement(Component, __assign({}, this.props, { value: this.store.value })));
            };
            StoreConnection.prototype.handleStoreUpdate = function () {
                this.setState(__assign({}, this.state));
            };
            StoreConnection.displayName = "StoreConnection(" + (Component.displayName || Component.name) + ")";
            return StoreConnection;
        }(React.Component));
        ;
        var WithContext = function (props) {
            return React.createElement(StoresContext_1.default.Consumer, null, function (context) {
                return React.createElement(StoreConnection, __assign({}, props, { stores: context.stores }));
            });
        };
        return WithContext;
    };
};
exports.default = connect;
//# sourceMappingURL=connect.js.map